// extracted by mini-css-extract-plugin
export default {"icon":"resetButtons_icon__vDrEe"};